/* src/app/components/controls/sem-data-grid/sem-data-grid.component.css */
.wg-doclib-file {
  display: flex;
  align-items: center;
  gap: .4rem;
  cursor: pointer;
  margin: 0;
}
.wg-doclib-file:hover .wg-doclib-file-name {
  text-decoration: underline;
}
.wg-doclib-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wg-doclib-file-icon {
  flex: 0 0 auto;
  width: 18px;
  height: 22px;
  border-radius: 2px;
  background: #94a3b8;
  position: relative;
  display: inline-block;
}
.wg-doclib-file-icon::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}
.wg-fi-pdf {
  background: #dc2626;
}
.wg-fi-doc {
  background: #2563eb;
}
.wg-fi-xls {
  background: #16a34a;
}
.wg-fi-img {
  background: #9333ea;
}
.wg-fi-generic {
  background: #94a3b8;
}
/*# sourceMappingURL=sem-data-grid.component.css.map */
